import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';
import { CompareTrayComponent } from '../ui-compare-tray/compare-tray.component';
import { CompareTrayFacade } from './compare-tray.facade';

// Compare is re-emitted rather than navigated: whoever mounts the tray owns its routing.
@Component({
  selector: 'rma-compare-tray-container',
  templateUrl: './compare-tray-container.component.html',
  imports: [CompareTrayComponent, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(COMPARE_AGENT_SCOPE), CompareTrayFacade],
})
export class CompareTrayContainerComponent {
  protected readonly facade = inject(CompareTrayFacade);

  protected readonly scope = COMPARE_AGENT_SCOPE;

  public readonly compare = output<void>();
}
